module.exports = __webpack_public_path__ + "static/media/2.c179ae55.jpg";